import React, { useCallback } from 'react';

import styled from 'styled-components';
import {
  Button, DialogActions,
  DialogContent, Grid, Typography
} from '@material-ui/core';

import { APP_PROFILE } from 'utils/constants';
import { translate } from 'utils';
import { CookiesHelper } from 'utils/helpers/CookiesHelper';
import sanitizeHtml from 'sanitize-html';
import { HeaderModal } from './_HeaderModal';

const StyledDialogContent = styled(DialogContent)`
  max-width: 800px;
  min-height: 245px;
`;

export const CookiesModal = ({
  onClose
}) => {
  const handleCloseWithoutAction = useCallback(() => {
    CookiesHelper.setGACookie(false);
    onClose();
  }, [onClose]);

  const handleCancel = useCallback(() => {
    CookiesHelper.setGACookie(false);
    onClose();
  }, [onClose]);

  const handleConfirm = useCallback(() => {
    CookiesHelper.setGACookie(true);
    onClose();
  }, [onClose]);

  return (
    <>
      <HeaderModal onClose={handleCloseWithoutAction}>
        <Typography variant="h4">
          {translate(
            'commons.rgpd.cookies.welcome',
            { applicationName: APP_PROFILE === 'AFF' ? "Clim'eco - commons" : 'Datatecnea' }
          )}
        </Typography>
      </HeaderModal>
      <StyledDialogContent>
        <Grid container spacing={1} style={{ marginTop: 5 }}>
          <Grid item xs={6}>
            <img alt="welcome" src={`${process.env.PUBLIC_URL}/assets/images/${APP_PROFILE === 'AFF' ? 'aff-welcome.png' : 'tecnea-welcome.png'}`} width="100%" />
          </Grid>
          <Grid item xs={6}>
            <Typography
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(translate('common.rgpd.cookies.popupIntro')) }}
              style={{ marginBottom: 20, fontSize: '1.7rem' }}
            />
          </Grid>
        </Grid>
        <Typography
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(translate('common.rgpd.cookies.defaultAction')) }}
          style={{ marginTop: 10, fontSize: '1.7rem' }}
        />
        <Typography
          dangerouslySetInnerHTML={{ __html: sanitizeHtml(translate('common.rgpd.cookies.howToChange')) }}
          style={{ marginTop: 10, fontSize: '1.7rem' }}
        />
      </StyledDialogContent>
      <DialogActions>
        <Grid container justifyContent="space-between" spacing={1} style={{ margin: 20 }}>
          <Grid item />
          <Grid item>
            <Grid container>
              <Grid item>
                <Button
                  color="secondary"
                  id="cancel"
                  style={{ marginRight: 30 }}
                  variant="contained"
                  onClick={handleCancel}
                >
                  {translate('button.refuse')}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  color="primary"
                  id="confirm"
                  variant="contained"
                  onClick={handleConfirm}
                >
                  {translate('button.accept')}
                </Button>
              </Grid>
            </Grid>
          </Grid>

        </Grid>
      </DialogActions>
    </>
  );
};
